/* ══════════════════════════════════════════════════════════════════
   MANUFAKTUR BAVARIA / ROBE SHOP — Universal Image Lightbox
   Self-contained. One file, deployed identically to both stores.
   - Runs on ALL pages (hero banners, content images, galleries).
   - Excludes product-media (handled by the dedicated product lightbox),
     product cards, header/footer/nav/logo, swatches, icons, tiny images.
   - Premium dark-glass overlay, arrows to browse, ESC / click-out / keyboard.
   - Language-aware aria labels (de / en) from <html lang>.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__mbUlb) return;          // never initialise twice
  window.__mbUlb = true;

  var LANG = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
  var T = LANG === 'de'
    ? { close: 'Schließen', prev: 'Vorheriges Bild', next: 'Nächstes Bild', dialog: 'Bild-Vergrößerung' }
    : { close: 'Close', prev: 'Previous image', next: 'Next image', dialog: 'Image enlargement' };

  var CSS =
    '.mb-ulb{position:fixed;inset:0;z-index:2147483600;display:none;align-items:center;justify-content:center;' +
    'padding:5vh 6vw;background:rgba(16,15,14,.93);backdrop-filter:blur(10px) saturate(120%);' +
    '-webkit-backdrop-filter:blur(10px) saturate(120%);opacity:0;transition:opacity .38s cubic-bezier(.22,1,.36,1);' +
    'cursor:zoom-out;-webkit-tap-highlight-color:transparent}' +
    '.mb-ulb.open{display:flex}' +
    '.mb-ulb.visible{opacity:1}' +
    '.mb-ulb>img{max-width:100%;max-height:88vh;width:auto;height:auto;object-fit:contain;border-radius:3px;' +
    'background:#fff;box-shadow:0 30px 90px rgba(0,0,0,.55);transform:scale(.96);' +
    'transition:transform .45s cubic-bezier(.22,1,.36,1);cursor:default}' +
    '.mb-ulb.visible>img{transform:scale(1)}' +
    '.mb-ulb button{position:absolute;background:rgba(0,0,0,.42);border:2px solid rgba(255,255,255,.7);color:#fff;' +
    'cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-backdrop-filter:blur(4px);' +
    'backdrop-filter:blur(4px);box-shadow:0 6px 20px rgba(0,0,0,.45);transition:background .25s,transform .25s;line-height:1}' +
    '.mb-ulb button:hover{background:rgba(0,0,0,.68);border-color:#fff;transform:scale(1.06)}' +
    '.mb-ulb .mb-ulb-prev,.mb-ulb .mb-ulb-next{top:50%;transform:translateY(-50%);width:56px;height:56px;border-radius:50%;font-size:24px}' +
    '.mb-ulb .mb-ulb-prev:hover,.mb-ulb .mb-ulb-next:hover{transform:translateY(-50%) scale(1.06)}' +
    '.mb-ulb .mb-ulb-prev{left:3vw}.mb-ulb .mb-ulb-next{right:3vw}' +
    '.mb-ulb .mb-ulb-close{top:24px;right:28px;width:46px;height:46px;border-radius:50%;font-size:24px}' +
    '.mb-ulb-cap{position:absolute;bottom:22px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,.72);' +
    'font-size:12px;font-family:"Montserrat",sans-serif;letter-spacing:.08em;text-transform:uppercase;text-align:center;max-width:80vw}' +
    'img.mb-ulb-able{cursor:zoom-in}' +
    '@media(max-width:600px){.mb-ulb .mb-ulb-prev{left:6px}.mb-ulb .mb-ulb-next{right:6px}' +
    '.mb-ulb .mb-ulb-prev,.mb-ulb .mb-ulb-next{width:44px;height:44px}.mb-ulb .mb-ulb-close{top:14px;right:14px;width:42px;height:42px}}';

  var overlay, view, cap, prevBtn, nextBtn;
  var items = [];      // { src, alt } of zoomable images, page order
  var idx = 0;

  function injectCSS() {
    if (document.getElementById('mb-ulb-css')) return;
    var s = document.createElement('style');
    s.id = 'mb-ulb-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'mb-ulb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', T.dialog);
    overlay.innerHTML =
      '<button class="mb-ulb-close" aria-label="' + T.close + '">&times;</button>' +
      '<button class="mb-ulb-prev" aria-label="' + T.prev + '">&#10094;</button>' +
      '<img alt="">' +
      '<button class="mb-ulb-next" aria-label="' + T.next + '">&#10095;</button>' +
      '<div class="mb-ulb-cap"></div>';
    document.body.appendChild(overlay);
    view = overlay.querySelector('img');
    cap = overlay.querySelector('.mb-ulb-cap');
    prevBtn = overlay.querySelector('.mb-ulb-prev');
    nextBtn = overlay.querySelector('.mb-ulb-next');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.mb-ulb-close').addEventListener('click', function (e) { e.stopPropagation(); close(); });
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  }

  function fullRes(src) {
    if (!src) return src;
    if (src.indexOf('shopify') > -1 || src.indexOf('/cdn/') > -1) {
      src = src.replace(/_(\d+x\d*|pico|icon|thumb|small|compact|medium|large|grande|master|original)\.(jpe?g|png|webp|gif)/i, '.$2');
      if (/[?&]width=\d+/.test(src)) src = src.replace(/([?&])width=\d+/, '$1width=2400');
    }
    return src;
  }

  function render() {
    var it = items[idx];
    view.src = it.src;
    view.alt = it.alt || '';
    cap.textContent = it.alt || '';
    cap.style.display = it.alt ? 'block' : 'none';
    var many = items.length > 1;
    prevBtn.style.display = many ? 'flex' : 'none';
    nextBtn.style.display = many ? 'flex' : 'none';
  }

  function open(k) {
    idx = k;
    render();
    overlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.add('visible'); }); });
  }
  function close() {
    overlay.classList.remove('visible');
    setTimeout(function () { overlay.classList.remove('open'); document.documentElement.style.overflow = ''; }, 380);
  }
  function step(d) { idx = (idx + d + items.length) % items.length; render(); }

  // ── which images become zoomable ──────────────────────────────────
  var SKIP_ANCESTOR = '.header,.footer,.announcement-bar,header,footer,nav,.logo-slider,' +
    '.product__media,.product__media-list,.product__media-wrapper,.card-wrapper,.product-card-wrapper,' +
    '.card__media,.card,.swatch,.variant,.payment,.mb-ulb,.rslb,.mblb,[class*="gpo-"],[class*="gpo_"],' +
    '.slideshow,.carousel-slide,.slick-slide,.swiper-slide,.mm-lb,.mm,.mm-card,.mbfc-wrap,[data-mbfc]';

  function badSrc(src) {
    src = (src || '').toLowerCase();
    return src.indexOf('logo') > -1 || src.indexOf('icon') > -1 || src.indexOf('fabric_card') > -1 || src.indexOf('seidenstrasse') > -1 ||
      src.indexOf('payment') > -1 || src.indexOf('.svg') > -1 || src.indexOf('data:image') === 0;
  }

  function collect() {
    var nodes = document.querySelectorAll('main img, .mb-hero-banner img, .shopify-section img');
    var out = [];
    var seenKey = {};
    [].forEach.call(nodes, function (img) {
      if (img.closest(SKIP_ANCESTOR)) return;
      // too small (icons/badges) — allow if not yet loaded but has big attribute width
      var w = img.naturalWidth || img.width || parseInt(img.getAttribute('width'), 10) || 0;
      if (w && w < 200) return;
      var src = img.currentSrc || img.src || img.getAttribute('src') || '';
      if (!src || badSrc(src)) return;
      // wrapped in a real navigational link → leave it (preserve navigation), unless flagged
      var a = img.closest('a');
      if (a && a.href && a.href.indexOf('#') === -1 && !img.hasAttribute('data-mb-zoom')) return;

      var full = fullRes(src);
      var key = full.split('?')[0];
      if (key in seenKey) { // duplicate image → still make clickable, point to first occurrence
        markClickable(img, seenKey[key]);
        return;
      }
      seenKey[key] = out.length;
      markClickable(img, out.length);
      out.push({ src: full, alt: img.alt || '' });
    });
    items = out;
  }

  function markClickable(img, index) {
    if (img.getAttribute('data-mbulb') === '1') { img.__mbi = index; return; }
    img.setAttribute('data-mbulb', '1');
    img.classList.add('mb-ulb-able');
    img.__mbi = index;
    img.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      collect();                 // refresh order/indices at click time
      var here = fullRes(img.currentSrc || img.src || '').split('?')[0];
      var found = 0;
      for (var i = 0; i < items.length; i++) { if (items[i].src.split('?')[0] === here) { found = i; break; } }
      open(found);
    }, true);                    // capture phase — beat Dawn/app handlers
  }

  function boot() {
    injectCSS();
    buildOverlay();
    collect();
    // re-scan for late-injected content (apps, customizer, lazy images)
    [400, 1200, 2500].forEach(function (t) { setTimeout(collect, t); });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
